/* eslint-disable max-len */

import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentRequirementItem } from 'app/models/document-requirement/document-requirement-item.model';
import { DealDocumentState } from 'app/store/deal/deal-documents/deal-document.state';
import { Store } from '@ngxs/store';
import { DocumentCategory } from 'app/models/document-requirement/document-category.model';

@Component({
    selector: 'document-requirement-list-item',
    standalone: true,
    templateUrl: './document-requirement-list-item.component.html',
    imports: [
        CommonModule,
        FormsModule,
        MatIconModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTooltipModule
    ]
})
export class DocumentRequirementListItemComponent implements OnInit {
    @Input() documentRequirement: DocumentRequirementItem;
    @Output() handleTimeClassification = new EventEmitter<{ documentRequirementItem: DocumentRequirementItem, index: number }>();
    @Output() handleRemove = new EventEmitter<number>();
    @Input() index: number;
    @Input() dealId: number;
    @Input() categories: DocumentCategory[];
    
    timeClassificationOptionsSignal = this.store.selectSignal(DealDocumentState.remainingTimeOptionsByRequiredDocumentCategory);
    timeClassificationOptions: {[key: string]: { display: string, value: string, parts: { month: number, year: number } } | string} = {};

    constructor(private store: Store) {}

    // Use ngOnInit to set the value after inputs are available
    ngOnInit() {
        if (this.dealId && this.categories) {
            this.timeClassificationOptions = this.timeClassificationOptionsSignal()(this.dealId, this.categories);
        }
    }

    updateMonthString({ value }) {
        this.handleTimeClassification.emit({ documentRequirementItem: { ...this.documentRequirement, monthValues: value }, index: this.index });
    }

    updateYearString({ value }) {
        this.handleTimeClassification.emit({ documentRequirementItem: { ...this.documentRequirement, yearsString: value }, index: this.index });
    }

    remove() {
        this.handleRemove.emit(this.index);
    }
}
